














import {Vue, Component, Watch} from 'vue-property-decorator'
import ConnectWalletModal from '@/components/walletConnection/ConnectWalletModal.vue'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {$} from '@/facade'
import NavbarWalletSessionDisconnected from '@/components/navbar/NavbarWalletSessionDisconnected.vue'
import NavbarWalletSessionConnected from '@/components/navbar/NavbarWalletSessionConnected.vue'

@Component({
  components: {
    NavbarWalletSessionDisconnected,
    NavbarWalletSessionConnected,
    ConnectWalletModal,
  },
  computed: {
    NetworkNamespace() {
      return NetworkNamespace
    },
  },
})
export default class NavbarWalletSession extends Vue {
  addresses: Record<NetworkNamespace, string | null> = {
    [NetworkNamespace.n3]: null,
    [NetworkNamespace.x]: null,
  }

  get isDisconnected(): boolean {
    return (
      !this.addresses[NetworkNamespace.n3] &&
      !this.addresses[NetworkNamespace.x]
    )
  }

  created() {
    this.onAddressChange(NetworkNamespace.n3, $.walletAdapter.n3Address)
    this.onAddressChange(NetworkNamespace.x, $.walletAdapter.xAddress)
  }

  formatWalletAddress(address: string | null): string | null {
    if (!address || !address.trim()) return null

    const trimmed = address.trim()

    return `${trimmed.slice(0, 5)}...${trimmed.slice(-5)}`
  }

  onAddressChange(namespace: NetworkNamespace, address: string | null) {
    this.addresses[namespace] = this.formatWalletAddress(address)
  }

  @Watch('$store.state.walletAdapter.n3.address')
  onN3AddressChange(newAddress: string | null) {
    this.onAddressChange(NetworkNamespace.n3, newAddress)
  }

  @Watch('$store.state.walletAdapter.neoX.address')
  onNeoXAddressChange(address: string | null) {
    this.onAddressChange(NetworkNamespace.x, address)
  }
}
